<div>
  <select class="form-select" [formControl]="brandInputCtrl" aria-label="Select Brand">
    <option value="" disabled>Select the brand</option>
    <option [value]="brand.id" *ngFor="let brand of brandList">{{brand.name}}</option>
  </select>
</div>
